// extracted by mini-css-extract-plugin
export default {"header":"HeaderProducts_header__GoqiA","headerSearch":"HeaderProducts_headerSearch__0e15r","headerButtons":"HeaderProducts_headerButtons__A1pCR"};